// extracted by mini-css-extract-plugin
module.exports = {"container":"_2A_vT","labelContainer":"_3MkPG","label":"_1c2Fy","containerWithLabel":"_1UKXz","text":"DGhD8","header":"YWdpT"};